import * as React from 'react';
import Box from '@mui/material/Box';
import ParentBox from '../components/ParentBox';
import SidebarMenu from "./SidebarMenu"; 
import "../css/reset.css";
import "../css/layout.css";
import "../css/common.css";
import "../css/style.css";
import "../css/dashboard.css";
import "../css/lnb.css";
import { WeatherPaper } from 'pages/components/WeatherPaper';
import { RiceBowl } from '@mui/icons-material';
import { SwItsBisCntTotalProvider, SwItsBisCntInfo, SwItsRunBisCntDetailInfo } from 'pages/components/dashboard/SwItsGetBisCnt';
import { SwItsBisPssngrDataProvider, SwItsBisPssngrTotalInfo } from 'pages/components/dashboard/SwItsGetBusPssngrData';
import { SwItsIndicatortsDataProvider, SwItsIndicatortsDataInfo } from 'pages/components/dashboard/SwItsGetThreeIndicatorsData';

import { useTranslation } from 'react-i18next';

export default function BusOperationViewD() {

    React.useEffect(() => {

    }, []);
    const { t, i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'ko' ? 'en' : 'ko';
        i18n.changeLanguage(newLang);
    };

    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <div className="dashboard container flx a_center">
                <SidebarMenu />
                <div className="ctrlMain">
                    <div className="mainTit flx j_spc_btw a_center">
                        <div className="titBox">
                            <p
                                className={`subTit${i18n.language === 'en' ? '_en' : ''}`}
                                onClick={toggleLanguage}
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                            >
                                {t('subtitle')}
                            </p>
                            <p className={`tit${i18n.language === 'en' ? '_en' : ''}`}>
                                {t('mainTitle4')}
                            </p>
                        </div>
                        <div className="weatherWrap flx a_center j_spc_btw">
                            <WeatherPaper />
                        </div>
                    </div>
                    <div className="mainInfo L_tb">{/*메인박스*/}
                        <div className='L_d L_lr'>
                            <div className='L_2m inner'>
                                <div className='titWrap flx j_spc_btw'>
                                    {/* <h2 className="boxTit" style={{color:'var(--iv-05)'}}>기반정보</h2> */}
                                    <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('BusOperationsSummary')}
                                    </h2>
                                </div>
                                <SwItsBisCntTotalProvider>
                                    <div className='busInfoConts flx a_center j_spc_btw'>
                                        <div className='center flx flx_col dvd'>
                                            <div className='mainBox flx flx_col a_center j_center'>
                                                <p>노선</p>
                                                <SwItsBisCntInfo title={'route'} />
                                            </div>
                                            <SwItsBisCntInfo title={'route'} detail />
                                        </div>
                                        <div className='left flx flx_col dvd'>
                                            <div className='mainBox flx flx_col a_center j_center'>
                                                <p>버스대수</p>
                                                <SwItsBisCntInfo title={'bus'} />
                                            </div>
                                            <SwItsBisCntInfo title={'bus'} detail />
                                        </div>
                                        <div className='right L_tb flx flx_col dvd'>
                                            <div className='mainBox L_d_i_10 innerBg flx flx_col a_center j_center'>
                                                <p>정류장</p>
                                                <SwItsBisCntInfo title={'station'} />
                                            </div>
                                            <div className='mainBox L_d_i_10 innerBg flx flx_col a_center j_center'>
                                                <p>BIT</p>
                                                <SwItsBisCntInfo title={'bit'} />
                                            </div>
                                        </div>
                                    </div>
                                </SwItsBisCntTotalProvider>
                            </div>
                            <div className='L_2m inner'>
                                <div className='titWrap flx j_spc_btw'>
                                     <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`}  style={{ color: 'var(--iv-07)' }}>{t('BISKeyIndicator')}
                                    </h2>
                                </div>
                                <SwItsIndicatortsDataProvider>
                                    <div className='idctDataConts'>
                                        <SwItsIndicatortsDataInfo />
                                    </div>
                                </SwItsIndicatortsDataProvider>

                            </div>
                        </div>
                        <div className='L_d L_lr'>
                            <SwItsBisCntTotalProvider>
                                <SwItsRunBisCntDetailInfo />
                            </SwItsBisCntTotalProvider>
                            <SwItsBisPssngrDataProvider>
                                <SwItsBisPssngrTotalInfo />
                            </SwItsBisPssngrDataProvider>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
    )
}